<template>
    <div class="pledge">

        <div class="banners" ref="bannersRef">
            <!-- 
            <el-carousel height="150px" :interval="3000" arrow="never">
                <el-carousel-item>
                    <img src="@/assets/images/mpc/banner.png"/>
                </el-carousel-item>
            </el-carousel> 
            -->
            <el-carousel class="defaultCarousel" :height="autoHeight+'px'">
                <el-carousel-item  >
                    <img src="@/assets/images/mpc/banner-en.png" v-if="curLang == 'en_us'"/>
                    <img src="@/assets/images/mpc/banner-cn.png" v-else/>
                </el-carousel-item>
                <!-- <el-carousel-item >
                    <img src="@/assets/images/mpc/banner.png"/>
                </el-carousel-item> -->
            </el-carousel>
        </div>

        <div class="qaiBox joinBox">
            <div class="types">
                <div @click="curMode = 1;" :class="curMode == 1? 'selected':''">
                    <!-- <img src="@/assets/images/mpc/mode1.png"/> -->
                    <span>{{$t("pledge.mode1")}}</span>
                </div>
                <div @click="curMode = 2;" :class="curMode == 2? 'selected':''">
                    <!-- <img src="@/assets/images/mpc/mode2.png"/> -->
                    <span>{{$t("pledge.mode2")}}</span>
                </div>
            </div>
            <div class="comments">
                <div class="comments-title">
                    <img src="@/assets/images/qai/question.png"/>
                    <span>{{$t('pledge.ruleLabel')}}：</span>
                </div>
                <p v-if="curMode == 1">{{$t('pledge.mode1Msg')}}</p>

                <p v-if="curMode == 2">{{$t('pledge.mode2Msg')}}</p>
            </div>
            <div class="rate">
                <span>1 MPC ≈ {{ mineParam.mpcPrice }} USDT</span>
                <span>{{$t('pledge.mpcPrice')}}</span>
            </div>
            <div class="amtBox">
                <div @click="curMul = 1;" :class="curMul == 1? 'selected':''">
                    <span>200</span>
                </div>
                <!-- <div @click="curMul = 5;" :class="curMul == 5? 'selected':''">
                    <span>1000</span>
                </div> -->
                <div @click="curMul = 10;" :class="curMul == 10? 'selected':''">
                    <span>2000</span>
                </div>
            </div>
            <div class="inputBox">
                <div v-if="curMode == 1">
                    <div class="common-input">
                        <div class="label">STC</div>
                        <div class="data">{{ mineParam.buy1StcAmt*curMul }}</div>
                        <img src="@/assets/images/mpc/STC.png"/>
                    </div>
                    <div class="value">
                        <div class="balance">
                            <span>STC {{$t("common.balance")}}:</span>
                            <span>{{ toDecimalVal(myStcBalance,4) }}</span>
                        </div>
                    </div>
                </div>
                <div v-if="curMode == 1" class="turn"><img src="@/assets/images/mpc/add.png"/></div>
                <div>
                    <div class="common-input">
                        <div class="label">MPC</div>
                        <div class="data" v-if="curMode == 1">{{ mineParam.buy1MpcAmt*curMul }}</div>
                        <div class="data" v-if="curMode == 2">{{ mineParam.buy2MpcAmt*curMul }}</div>
                        <img src="@/assets/images/mpc/MPC.png"/>
                    </div>
                    <div class="value">
                        <div class="balance">
                            <span>MPC {{$t("common.balance")}}:</span>
                            <span>{{ toDecimalVal(myMpcBalance,4) }}</span>
                        </div>
                    </div>
                </div>
                <div class="func" @click="confirmPledge">{{$t('common.confirm')}}</div>
            </div>
        </div>
        <div class="title2">{{$t('pledge.myOrder')}}</div>
        <div class="orders" v-if="orderList && orderList.length>0">
            <div class="order" v-for="(item,index) in orderList" :key="index" :class="'status1'">
                <div class="status">
                    <img src="@/assets/images/mpc/mode1.png" v-if="item.mode == 1"/>
                    <img src="@/assets/images/mpc/mode2.png" v-if="item.mode == 2"/>
                    <span>{{$t("pledge.mode"+item.mode)}}</span>
                </div>
                <div class="content">
                    <p>
                        <span>{{$t("pledge.time")}}</span>
                        <span>{{formatTimestamp(item.buyTime * 1000,"yyyy-MM-dd hh:mm")}}</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.amount")}}</span>
                        <span v-if="item.mode == 1">{{convertUp(item.stcAmt,18,2)}} STC + {{convertUp(item.mpcAmt,18,2)}} MPC</span>
                        <span v-else-if="item.mode == 2">{{convertUp(item.mpcAmt,18,2)}} MPC</span>
                        <span v-else>--</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.value")}}</span>
                        <span>{{convertUp(item.value,18,2)}} USDT</span>
                    </p>
                    <p>
                        <span>{{$t("pledge.profit")}}</span>
                        <span>{{convertUp(item.profit,18,2)}} USDT</span>
                    </p>
                    <!-- <p>
                        <span>已释放</span>
                        <span>{{convertUp(item.released,18,6)}} USDT</span>
                    </p>
                    <p>
                        <span>最近结算时间</span>
                        <span>{{formatTimestamp(item.lastTime * 1000,"yyyy-MM-dd hh:mm")}}</span>
                    </p> -->
                </div>
            </div>
        </div>
        <div class="noData" v-else>
            <img src="@/assets/images/qai/empty.png"/>
            <span>{{$t('common.noData')}}</span>
        </div>
    </div>
</template>

<script>
import bus from '@/assets/js/bus';
import { getUserName} from '@/assets/js/user';
import { getLanguage,setLanguage} from '@/assets/js/config';
import Web3 from 'web3';
export default {
	data() {
		return {
            walletAddress: "",
            web3Instance:null,
            mpcTeamContractInstance:null,
            mpcHomeContractInstance:null,
            tokenMpcContractInstance:null,
            tokenStcContractInstance:null,

            myParent:"",
            myMpcBalance:0,
            myStcBalance:0,

            mineParam:{
                mpcPrice:0,
                buy1StcAmt:0,
                buy1MpcAmt:0,
                buy2MpcAmt:0,
            },

            curMode:1,
            curMul:1,
            orderList:[],

            sysParam:{},
            autoHeight:0,
            curLang:"",
		};
	},
    created() {
        
        this.curLang = getLanguage() || 'zh_cn';
        bus.$off('clearWalletAddress');
        bus.$off('refreshWalletData');
        bus.$on('clearWalletAddress',async() =>  {
            this.web3Instance = null;
            this.mpcTeamContractInstance = null;
            this.mpcHomeContractInstance = null;
            this.tokenMpcContractInstance = null;
            this.tokenStcContractInstance = null;
        });
        bus.$on('refreshWalletData',async(msg) =>  {
            this.walletAddress = getUserName();
            this.initWallet();
        });
        bus.$on('changeLang',async(msg) =>  {
            this.curLang = getLanguage() || 'zh_cn';
        });
    },
    mounted() {
        if(getUserName()){
            this.hideConnectWalletBox();
            this.walletAddress = getUserName();
            this.initWallet();
        }else{
            this.showConnectWalletBox();
            this.connectWallet();
        }
        if(this.isMobile()){
            this.$nextTick(() => {
                // 获取元素的宽度;
                let width = this.$refs.bannersRef.offsetWidth;
                this.autoHeight = width*308/690 + 30;
            });
        }else{
            this.autoHeight = 374*308/690 + 30;
        }

        // this.showNoticeBox();
    },
    methods: {
        choosed(command){
            if(command == "language"){
                this.showLanguageDialog();
            }else if(command == "Home"){
                this.locationAnchor("#main-ido");
            }if(command == "notStart"){
                this.$message.warning(this.$t('common.notStart'));
            }else if(command == "Pancake"){
                let url = "https://pancakeswap.finance/swap?outputCurrency="+this.futAddress+"&inputCurrency="+this.usdtAddress;
                window.open(url,"_blank");
            }else if(command == "Telegram"){
                window.open("https://t.me/Quantum_AI_id","_blank");
            }else if(command == "Twitter"){
                window.open("https://x.com/quantum_ai_x?s=21");
            }else if(command == "WhitePaper"){
                window.open(`${window.location.protocol}//${window.location.host}/whitepaper.docx`,"_blank");
            }else{
                this.goPage(command)
            }
        },
        changeLpAmount() {
            var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
            if (reg.test(this.lpAmount)) {
                this.lpAmount = this.lpAmount.toString().replace(reg, '$2$3$4');
                if(this.lpPrice>0 && this.qmxPrice>0){
                    this.qmxAmount = this.toDecimalVal((this.lpAmount * this.lpPrice * 0.3 / this.qmxPrice),6);
                }
            } else {
                this.qmxAmount = '';
                this.lpAmount = '';
            }
        },
        changeQmxAmount() {
            var reg = /^(\.*)(\d+)(\.?)(\d{0,6}).*$/g
            if (reg.test(this.qmxAmount)) {
                this.qmxAmount = this.qmxAmount.toString().replace(reg, '$2$3$4');
                if(this.lpPrice>0 && this.qmxPrice>0){
                    this.lpAmount = this.toDecimalVal((this.qmxAmount * this.qmxPrice * 10 /3) / this.lpPrice,6);
                }
            } else {
                this.qmxAmount = '';
                this.lpAmount = '';
            }
        },
        maxLpAmount(){
            this.lpAmount = this.toDecimalVal(this.myLpBalance,4);
            this.changeLpAmount();
        },
        maxQmxAmount(){
            this.qmxAmount = this.toDecimalVal(this.myQmxBalance,4);
            this.changeQmxAmount();
        },
        initWallet(){
            this.web3Instance = new Web3(window.ethereum);
            this.mpcTeamContractInstance = new this.web3Instance.eth.Contract(this.MpcTeam_Contract.abi, this.MpcTeam_Contract.address);
            this.mpcHomeContractInstance = new this.web3Instance.eth.Contract(this.MpcHome_Contract.abi, this.MpcHome_Contract.address);
            this.tokenMpcContractInstance = new this.web3Instance.eth.Contract(this.TokenMpc_Contract.abi, this.TokenMpc_Contract.address);
            this.tokenStcContractInstance = new this.web3Instance.eth.Contract(this.TokenStc_Contract.abi, this.TokenStc_Contract.address);

            // if(this.walletAddress.toLocaleLowerCase() == this.initiatorAddress.toLocaleLowerCase()){
            //     this.hideBindParentBox();
            // }else{
                
            // }
            this.mpcTeamContractInstance.methods.findUserParent(this.walletAddress).call().then((result) => {
                if(result != "0x0000000000000000000000000000000000000000"){
                    this.myParent = result;
                    this.hideBindParentBox();
                }else{
                    this.showBindParentBox();
                }
            });

            this.refreshWalletData();
        },
        refreshWalletData(){
            this.showLoadingBox();
            this.tokenMpcContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myMpcBalance = this.convertFromByUnit(result,18);
            });
            this.tokenStcContractInstance.methods.balanceOf(this.walletAddress).call().then((result) => {
                this.myStcBalance = this.convertFromByUnit(result,18);
            });
            this.mpcHomeContractInstance.methods.findMineParam().call().then((result) => {
                this.hideLoadingBox();
                console.log(result);
                this.mineParam = {
                    mpcPrice:this.convertUp(result._mpcPrice,18),
                    buy1StcAmt:this.convertUp(result._buy1StcAmt,18),
                    buy1MpcAmt:this.convertUp(result._buy1MpcAmt,18),
                    buy2MpcAmt:this.convertUp(result._buy2MpcAmt,18),
                }
            });
            this.mpcHomeContractInstance.methods.findUserPledgeOrders(this.walletAddress).call().then((result) => {
                this.hideLoadingBox();
                let orderList = [];
                for(let order of result){
                    orderList.push(order);
                }
                orderList.reverse();
                this.orderList = orderList;
            });
        },
        async confirmPledge(){
            let _this = this;
            if(!this.mpcHomeContractInstance){
                return;
            }
            if(this.orderList.length>=100){
                this.$message.warning({message: this.$t("pledge.outOrderLimit"),duration: 1500})
                return;
            }
            if(this.curMode == 1){
                let stcAmt = this.mineParam.buy1StcAmt * this.curMul;
                let mpcAmt = this.mineParam.buy1MpcAmt * this.curMul;
                if(stcAmt > this.myStcBalance || this.myStcBalance <= 0){
                    this.$message.warning({message: this.$t("common.stcBalanceOut"),duration: 1500})
                    return;
                }
                if(mpcAmt > this.myMpcBalance || this.myMpcBalance <= 0){
                    this.$message.warning({message: this.$t("common.mpcBalanceOut"),duration: 1500})
                    return;
                }
                this.showConfirmBox(3,"STC","MPC");
                let stcFinalBigNumber = this.convertToBigNumberByUnit(stcAmt,18);
                let stcAllowance = await this.tokenStcContractInstance.methods.allowance(this.walletAddress, this.MpcHome_Contract.address).call();
                let stcAllowanceBigInt = this.convertToBigIntByUnit(stcAllowance,0);
                let finalBigInt1 = this.convertToBigIntByUnit(stcAmt,18);
                if(finalBigInt1 > stcAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenStcContractInstance,this.walletAddress,this.MpcHome_Contract.address,stcFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveStcFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                this.setConfirmBox(2);
                let mpcFinalBigNumber = this.convertToBigNumberByUnit(mpcAmt,18);
                let mpcAllowance = await this.tokenMpcContractInstance.methods.allowance(this.walletAddress, this.MpcHome_Contract.address).call();
                let mpcAllowanceBigInt = this.convertToBigIntByUnit(mpcAllowance,0);
                let finalBigInt2 = this.convertToBigIntByUnit(mpcAmt,18)
                if(finalBigInt2 > mpcAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenMpcContractInstance,this.walletAddress,this.MpcHome_Contract.address,mpcFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveMpcFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                this.setConfirmBox(3);
            }else{
                let mpcAmt = this.mineParam.buy2MpcAmt * this.curMul;
                if(mpcAmt > this.myMpcBalance || this.myMpcBalance <= 0){
                    this.$message.warning({message: this.$t("common.mpcBalanceOut"),duration: 1500})
                    return;
                }
                this.showConfirmBox(2,"MPC");
                let mpcFinalBigNumber = this.convertToBigNumberByUnit(mpcAmt,18);
                let mpcAllowance = await this.tokenMpcContractInstance.methods.allowance(this.walletAddress, this.MpcHome_Contract.address).call();
                let mpcAllowanceBigInt = this.convertToBigIntByUnit(mpcAllowance,0);
                let finalBigInt2 = this.convertToBigIntByUnit(mpcAmt,18)
                if(finalBigInt2 > mpcAllowanceBigInt){
                    if(!await this.tokenApprove(this.tokenMpcContractInstance,this.walletAddress,this.MpcHome_Contract.address,mpcFinalBigNumber)){
                        this.$message.warning({message:  this.$t("common.approveMpcFail"),duration: 1500});
                        this.hideConfirmBox();
                        return;
                    }
                }
                this.setConfirmBox(2);
            }

            let method = this.mpcHomeContractInstance.methods.buy(this.curMode,this.curMul);
            let bnbAmount = null;

            let gasprice = await this.web3Instance.eth.getGasPrice();
            console.log("gasPrice:",gasprice);
            method.estimateGas({from: this.walletAddress, value:bnbAmount}).then(function(result){
                console.log("estimateGas:",result);
            }).catch((err) => {
                console.log("estimateGas:",err)
            });

            this.contractSend(method,this.walletAddress,bnbAmount).then(function(result){
                _this.hideConfirmBox();
                if(result.status){
                    _this.$message.success({message: _this.$t("pledge.pledgeSuccess"),duration: 1500});
                    _this.refreshWalletData();
                }else{
                    _this.$message.error({message: _this.$t("pledge.pledgeFail"),duration: 1500});
                }
            }).catch((err) => {
                _this.hideConfirmBox();
                _this.$message.error({message: _this.$t("pledge.pledgeFail"),duration: 1500});
            });
        }
    },
    beforeDestroy() {
    }
};
</script>
<style lang='less' scoped>
.pledge{
    padding-top: 10px;
    padding-bottom: 100px;
    .banners{
        margin: 0px 10px;
        img{
            width: 100%;
            height: auto;
            border-radius: 5px;
        }
    }

    .joinBox{
        margin:0px 10px;
        .types{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap:10px;
            div{
                flex:1;
                height:40px;
                cursor: pointer;
                // background:url('~@/assets/images/mpc/tab.png') 0px 0px no-repeat;
                // background-size: 100% 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                gap:4px;
                img{
                    // width: 18px;
                    height: 22px;
                    width: auto;
                    // border-radius: 18px;
                    // border: 1px solid #868686;
                }
                span{
                    color: #ffffff;
                    font-size: 14px;
                }
            }
            .selected{
                span{
                    color: #00CCFF !important;
                }
                background:url('~@/assets/images/mpc/tab.png') 0px 0px no-repeat;
                background-size: 100% 100%;
            }
        }
        .amtBox{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap:10px;
            margin: 15px 0px;
            div{
                height:25px;
                width: 50px;
                line-height: 25px;
                cursor: pointer;
                padding: 0px 10px;
                border-radius: 30px;
                border: 1px solid #9ABCDF;
                span{
                    color: #9ABCDF;
                    font-size: 13px;
                    font-weight: bold;
                }
            }
            .selected{
                background: #3161E7;
                border: 1px solid #3161E7;
                span{
                    color: #ffffff;
                    font-size: 13px;
                }
            }
        }
        .comments{
            margin-top: 15px;
            padding: 18px 20px;
            background:url('~@/assets/images/mpc/bg-msg.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            color: #ffffff;
            .comments-title{
                display: flex;
                align-items: center;
                img{
                    width: 13px;
                    height: 13px;
                    margin-right: 3px;
                }
                span{
                    font-size: 12px;
                    font-weight: bold;
                }
            }
            p{
                margin: 6px 0px 0px 0px;
                padding:0px;
                font-size: 12px;
                text-align: left;
                // color: #747A9A;
                color: #9ABCDF;
            //     background: -webkit-linear-gradient(0deg, #32D8FF, #006CEA);
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
            }
        }
        .rate{
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin: 15px 0px;
            span:first-child{
                font-weight: bolder;
                font-size: 16px;
                color: #ffffff;
            }
            span:last-child{
                font-size: 12px;
                color: #747A9A;
            }
        }
        .inputBox{
            margin-top: 15px;
        }
        .turn{
            margin: 3px auto 10px auto;
            img{
                height: 28px;
                width: auto;
            }
        }
        .value{
            margin:4px 5px 0px 5px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .balance{
                display: flex;
                align-items: center;
                font-size: 13px;
                color:#9ABCDF;
                line-height: 13px;
                span:first-child{
                    font-size: 12px;
                }
                span:last-child{
                    margin-left:3px;
                }
            }
        }
        .func {
            margin-top: 25px;
            font-size: 14px;
            height: 45px;
            line-height: 45px;
            color:#000000;
            text-align: center;
            cursor: pointer;
            background:url('~@/assets/images/mpc/bg-btn.png') 0px 0px no-repeat;
            background-size: 100% 100%;
        }
    }

    .orders{
        margin: 10px 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        .order{
            background:url('~@/assets/images/mpc/bg-order.png') 0px 0px no-repeat;
            background-size: 100% 100%;
            padding: 12px 15px;
            .status{
                display: flex;
                align-items: center;
                margin-bottom: 5px;
                img{
                    // width: 14px;
                    height: 25px;
                    width: auto;
                    margin-right: 8px;
                }
                span{
                    font-size: 15px;
                    font-weight: bold;
                    color: #ffffff;
                }
            }
            .content{
                width: 100%;
                display: flex;
                flex-direction: column;
                gap: 5px;
                p{
                    padding: 0px;
                    margin: 0px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span:first-child{
                        font-size: 13px;
                        color: #9ABCDF;
                    }
                    span:last-child{
                        font-size: 14px;
                        color: #ffffff;
                    }
                }
            }
        }
    }
}
</style>